import React, { useState } from 'react';
import { Star, Quote } from 'lucide-react';
import LeadCaptureModal from './LeadCaptureModal';

const Testimonials = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const testimonials = [
    {
      name: 'Rajesh Patel',
      location: 'Ahmedabad, Gujarat',
      business: 'Dairy Farm Owner (200+ Cattle)',
      testimonial: 'Simran Industries cotton seed cake has significantly improved our milk production. The quality is consistent and our cattle health has visibly improved. Highly recommended!',
      rating: 5,
      image: 'https://images.pexels.com/photos/1212984/pexels-photo-1212984.jpeg'
    },
    {
      name: 'Suresh Kumar',
      location: 'Jaipur, Rajasthan',
      business: 'Livestock Distributor',
      testimonial: 'We have been partnering with Simran Industries for over 8 years. Their timely delivery and premium quality products have helped us serve our customers better.',
      rating: 5,
      image: 'https://images.pexels.com/photos/1681010/pexels-photo-1681010.jpeg'
    },
    {
      name: 'Priya Sharma',
      location: 'Bhopal, Madhya Pradesh',
      business: 'Dairy Cooperative President',
      testimonial: 'The nutritional value and affordability of their feed products have made a remarkable difference in our cooperative\'s productivity. Excellent customer service too!',
      rating: 5,
      image: 'https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg'
    },
    {
      name: 'Amit Singh',
      location: 'Lucknow, Uttar Pradesh',
      business: 'Commercial Dairy Operation',
      testimonial: 'Outstanding quality! Our milk yield increased by 15% within 2 months of switching to Simran Industries feed. The investment has definitely paid off.',
      rating: 5,
      image: 'https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-amber-600 to-yellow-600">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            What Our Customers Say
          </h2>
          <p className="text-xl text-yellow-100 max-w-3xl mx-auto leading-relaxed">
            Don't just take our word for it. Here's what dairy farmers and distributors 
            across India say about our products and services.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white/95 backdrop-blur-sm rounded-2xl p-8 shadow-2xl hover:shadow-3xl transition-all duration-200 hover:scale-[1.02]">
              <div className="flex items-center mb-6">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full mr-4 object-cover"
                />
                <div>
                  <h4 className="font-bold text-amber-800 text-lg">{testimonial.name}</h4>
                  <p className="text-gray-600 text-sm">{testimonial.business}</p>
                  <p className="text-amber-600 text-sm font-medium">{testimonial.location}</p>
                </div>
              </div>

              <div className="relative mb-6">
                <Quote className="absolute -top-2 -left-2 text-amber-200" size={32} />
                <p className="text-gray-700 leading-relaxed pl-8 italic">
                  "{testimonial.testimonial}"
                </p>
              </div>

              <div className="flex items-center">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="text-yellow-400 fill-current" size={20} />
                ))}
                <span className="ml-2 text-gray-600 font-medium">
                  {testimonial.rating}.0/5.0
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-white mb-4">
              Join 10,000+ Satisfied Customers
            </h3>
            <p className="text-yellow-100 mb-6 text-lg">
              Experience the difference premium quality feed can make to your dairy business.
            </p>
            <button 
              onClick={handleOpenModal}
              className="bg-white text-amber-600 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all duration-200 hover:scale-105 shadow-lg"
            >
              Start Your Success Story
            </button>
          </div>
        </div>
      </div>
      
      <LeadCaptureModal 
        isOpen={isModalOpen} 
        onClose={handleCloseModal}
        productName="General Enquiry"
      />
    </section>
  );
};

export default Testimonials;